import { render, staticRenderFns } from "./news.vue?vue&type=template&id=6b669c76&scoped=true"
import script from "./news.vue?vue&type=script&lang=js"
export * from "./news.vue?vue&type=script&lang=js"
import style0 from "./news.vue?vue&type=style&index=0&id=6b669c76&prod&lang=less&scoped=true"
import style1 from "./news.vue?vue&type=style&index=1&id=6b669c76&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b669c76",
  null
  
)

export default component.exports